// extracted by mini-css-extract-plugin
module.exports = {"root":"TabNav_root__2zXIm","tab":"TabNav_tab__39qkw","link":"TabNav_link__wwkNr","selectedLink":"TabNav_selectedLink__1VCE8","disabled":"TabNav_disabled__1GOZ7"};